{
  "page": {
    "title": "ส่งออกคำสั่งซื้อ"
  },
  "field": {
    "seller": "ผู้ขาย",
    "date_range": "ช่วงวันที่"
  },
  "placeholder": {
    "select_range": "เลือกช่วงวันที่…"
  },
  "action": {
    "generate": "สร้างการส่งออก"
  },
  "column": {
    "filename": "ไฟล์",
    "generated": "สร้างเมื่อ",
    "download": "ดาวน์โหลด"
  }
}
